import React from "react";
export class EmbeddedTabStrip extends React.Component<EmbeddedTabStripProps, EmbeddedTabStripState>{

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        };
    }

    static getDerivedStateFromProps(props: EmbeddedTabStripProps, state: EmbeddedTabStripState): EmbeddedTabStripState {
        let newState = {...state};
        if (props.children.length <= state.activeIndex)
            newState.activeIndex = 0;
        return newState;
    } 
    
    private getHeaderContent = () => {
        const activeClasses = `${EmbeddedTabStripCSSClasses.EmbeddedTabsHeaderItem} ${EmbeddedTabStripCSSClasses.EmbeddedTabsHeaderItemActive}`;
        return React.Children.map(this.props.children, (child, index) => {
            let icon = this.props.headerIcons[index] || "eye";
            let iconString = `fal fa-${icon}`;
            return (<div className={index === this.state.activeIndex ? activeClasses : EmbeddedTabStripCSSClasses.EmbeddedTabsHeaderItem}
                onClick={(e) => { this.onTabHeaderClick(index) }}>
                <i className={iconString}></i>
            </div>);
        });
    }

    private getTabsContent = () => {
        const activeClasses = `${EmbeddedTabStripCSSClasses.EmbeddedTabsContentItem} ${EmbeddedTabStripCSSClasses.EmbeddedTabsContentItemActive}`;
        return React.Children.map(this.props.children, (child: any, index) => {
            if (child != null) {
                const clonedChild = React.cloneElement(child);
                return (<div className={index === this.state.activeIndex ? activeClasses : EmbeddedTabStripCSSClasses.EmbeddedTabsContentItem}>
                    {index === this.state.activeIndex ? <div style={{ height: "100%" }}>{clonedChild}</div> : <div style={{ display: "none" }}> {clonedChild}</div>}
                </div>);
            }
            return null;
        });
    }

    private onTabHeaderClick = (index: number) => {

        this.setState({ activeIndex: index }, () => {
            if (typeof this.props.onTabSelected === "function") {
                this.props.onTabSelected(this.state.activeIndex);
            }
        });
    }

    render() {
        return (<div className="embedded-tabs">
            <div className="embedded-tabs__header">
                {this.getHeaderContent()}
            </div>
            <div className="embedded-tabs__content">
                {this.getTabsContent()}
            </div>
        </div>);
    }
}

enum EmbeddedTabStripCSSClasses {
    EmbeddedTabs = "embedded-tabs",
    EmbeddedTabsHeader = "embedded-tabs__header",
    EmbeddedTabsContent = "embedded-tabs__content",
    EmbeddedTabsHeaderItem = "embedded-tabs__tab-header-item",
    EmbeddedTabsHeaderItemActive = "embedded-tabs__tab-header-item--active",
    EmbeddedTabsContentItem = "embedded-tabs__tab-content-item",
    EmbeddedTabsContentItemActive = "embedded-tabs__tab-content-item--active"
}

interface EmbeddedTabStripState {
    activeIndex: number;
}

export interface EmbeddedTabStripProps extends React.PropsWithChildren{
    headerIcons?: Array<string>
    onTabSelected?: (index: number) => void;
    children?: any
}
